:host {
  display: block;
  font-family: inherit;

  --row-gap: 0.5rem;
  --row-margin: 1rem;
  --label-weight: 600;
  --label-color: #333;
  --label-size: 0.9rem;
  --values-gap: 0.5rem;
  --value-bg: #f8f9fa;
  --value-border: 1px solid #e1e5e9;
  --value-radius: 4px;
  --value-color: #333;
  --value-font-size: 0.875rem;
  --value-padding: 0.5rem 1rem;
  --value-hover-bg: #e9ecef;
  --value-hover-border: #adb5bd;
  --value-active-bg: #007bff;
  --value-active-border: #007bff;
  --value-active-color: white;
  --value-active-hover-bg: #0056b3;
  --value-active-hover-border: #0056b3;
  --value-focus-color: #007bff;
  --loading-opacity: 0.7;
}

:host([loading]) {
  opacity: var(--loading-opacity);
}

.selector {
  display: block;
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--row-gap);
  margin-bottom: var(--row-margin);
}

.row:last-child {
  margin-bottom: 0;
}

.label {
  font-weight: var(--label-weight);
  color: var(--label-color);
  font-size: var(--label-size);
}

.values {
  display: flex;
  flex-wrap: wrap;
  gap: var(--values-gap);
}

.value {
  background: var(--value-bg);
  border: var(--value-border);
  color: var(--value-color);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--value-font-size);
  padding: var(--value-padding);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.value:hover {
  background: var(--value-hover-bg);
  border-color: var(--value-hover-border);
}

.value.active {
  background: var(--value-active-bg);
  border-color: var(--value-active-border);
  color: var(--value-active-color);
}

.value.active:hover {
  background: var(--value-active-hover-bg);
  border-color: var(--value-active-hover-border);
}
